<template>
    <v-container class="my-5">
        <!--    Diálogo Persistente para mostrar Correccion de Datos    -->
        <v-dialog v-model="dialog_correction_request" persistent width="500">
            <v-card class="justify-center">
                <v-card-title class="primary display-1 text--primary justify-center">
                    {{$t('data_correction')}}
                </v-card-title>
                <v-card-text align="center">
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="first_name_correction"
                          prepend-icon="mdi-account"
                          name="first_name"
                          :label="$t('Nombre')"
                          :error-messages="errores.first_name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="last_name_correction"
                          prepend-icon="mdi-account-outline"
                          name="last_name"
                          :label="$t('Apellido')"
                          :error-messages="errores.last_name"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                          v-model="msg_photograph_blurred"
                          :label="$t('msg_photograph_blurred')">
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_correction_request = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                            color="primary"
                            :loading="loading_correction_request"
                            @click="send_correction_request()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para modificar Datos del Invitado    -->
        <v-dialog v-model="dialog_errores" persistent width="500"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text align="center">
                    <h3 class="text-xs-center">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', activar_camara = true"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entradaResidente" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_residente')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.resident).length > 0">
                          <v-layout justify-center class="text-xs-center" row wrap>
                            <v-alert
                                v-show="info_invitation.resident.vacation_mode && !info_invitation.resident.allow_access_residents"
                                type="error"
                            >
                                <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                            </v-alert>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.resident.idUser.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('residente')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.idUser.first_name}}
                                                        {{ info_invitation.resident.idUser.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.street}} {{info_invitation.resident.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{  info_invitation.resident.idUser.cellNumber}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="success"
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-alert
                                    v-show="info_invitation.invitation.supplier"
                                    type="info"
                                >
                                  <strong>{{$t('supplier_mode')}}</strong>{{$t('msg_supplier')}}
                                </v-alert>
                                <v-alert
                                    v-show="info_invitation.invitation.vacation_mode && !info_invitation.invitation.allow_access_visitors"
                                    type="error"
                                >
                                  <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                </v-alert>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.correction_request === false">
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                    <h2 v-else style="color: red">
                                                        {{ info_invitation.invitation.first_name}}
                                                        {{ info_invitation.invitation.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-show="info_invitation.invitation.correction_request === false" align-center justify-center row wrap>
                                    <v-btn
                                        large
                                        color="error"
                                        @click="id_user_settings = info_invitation.invitation.id_user_settings, first_name_correction = info_invitation.invitation.guestFName, last_name_correction = info_invitation.invitation.guestLName, msg_photograph_blurred = true, errores = [], dialog_correction_request = true"
                                    >{{$t('send_correction_request')}}
                                    </v-btn>
                                </v-layout>
                                <v-layout v-show="info_invitation.invitation.correction_request === true" align-center justify-center row wrap>
                                    <v-btn
                                        disabled
                                        large
                                        color="error"
                                    >{{$t('data_correction_sent')}}
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                            <v-divider :inset="false"></v-divider>
                            <v-flex v-show="getProfile.enable_host_info" xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                v-if="getProfile.enable_ine_photo"
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else
                                                :src="info_invitation.invitation.avatarHost"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="text-center">
                  <v-flex xs12>
                    <v-text-field
                        :disabled="!entrada"
                        class="mr-5 ml-5"
                        v-model="comments"
                        name="comments"
                        outlined
                        autocomplete="off"
                        maxlength="300"
                        prepend-icon="mdi-text"
                        :label="$t('Notas')"
                        :error-messages="errores.commnets"
                    ></v-text-field>
                    <v-btn
                            large
                            color="error"
                            @click="dialog = false, activar_camara = true"
                    >{{this.$t('cerrar')}}
                    </v-btn>
                    <v-btn
                            large
                            color="success"
                            @click="create_acceso(), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                    >{{$t('acceso')}}
                    </v-btn>
                  </v-flex>
                </v-card-actions>
            </v-card>
            <v-card v-if="entradaTrabajador || salidaTrabajador" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.worker).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_worker')}}</h2>
                                <br>
                                <v-alert
                                    v-show="info_invitation.worker.vacation_mode && !info_invitation.worker.allow_access_workers"
                                    type="error"
                                >
                                  <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                </v-alert>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.worker.avatar"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('worker')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.first_name}}
                                                        {{ info_invitation.worker.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.street}} {{info_invitation.worker.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('check_in_time')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.check_in_time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('check_out_time')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.check_out_time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inicial')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.initial_date }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.final_date }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.worker.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="error"
                            @click="dialog = false, activar_camara = true"
                    >{{this.$t('cerrar')}}
                    </v-btn>
                    <v-btn
                            v-if="entradaTrabajador"
                            large
                            color="success"
                            @click="create_worker_acceso(), dialog = false, qr_code='', activar_camara = true"
                    >{{$t('acceso')}}
                    </v-btn>
                    <v-btn
                            v-else
                            large
                            color="success"
                            @click="create_worker_acceso(), dialog = false, qr_code='', activar_camara = true"
                    >{{$t('registrar_salida')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex v-show="getProfile.enable_host_info" xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                v-if="getProfile.enable_ine_photo"
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else
                                                :src="info_invitation.invitation.avatarHost"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('celular')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('numero_casa')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_access')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de acceso')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_EntranceAccess}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de salida')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_ExitAccess ? data_access[0].dateTime_ExitAccess : "Pendiente" }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Estado')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{data_access[0].status == '1' ? "Adentro" : "Afuera"}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialog = false, activar_camara = true"
                        >{{ $t('cerrar')}}
                        </v-btn>
                        <v-btn
                                large
                                color="success"
                                @click="update_acceso(data_access[0].id), activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex>
              <v-card>
                <v-card-title class="primary white--text text-h5">
                  {{ $t('events') }}
                </v-card-title>
                <v-card-text>
                  <v-row v-if="events.length === 0">
                    <div>
                      <h3 class="text-h5 mt-2 mb-2 text-align-center">
                        {{ $t('no_records_yet') }}
                      </h3>
                    </div>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12" sm="4">
                      <v-treeview
                        :active.sync="active"
                        :items="events"
                        :load-children="fetchUsers"
                        :open.sync="open"
                        activatable
                        color="primary"
                        open-on-click
                        transition
                      >
                        <template v-slot:prepend="{ item }">
                          <v-icon v-if="!item.children">
                            mdi-calendar-star
                          </v-icon>
                        </template>
                      </v-treeview>
                    </v-col>
                    <!-- <v-divider vertical></v-divider> -->
                    <v-col cols="12" sm="8">
                      <v-scroll-y-transition mode="out-in">
                        <div
                          v-if="!selected"
                        >
                          Selecciona un Evento
                        </div>
                        <v-card
                          v-else
                          :key="selected.id"
                        >
                          <v-card-text>
                            <h3 class="text-h5 mb-2">
                              {{ selected.name }}
                            </h3>
                            <div class="black--text mb-2">
                              {{ selected.address }}
                            </div>
                            <div class="black--text mb-2">
                              {{ selected.date }}  {{ selected.time }}
                            </div>
                            <v-flex >
                                <v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="searchEvents"
                                            append-icon="mdi-magnify"
                                            :label="$t('search_by_name')"
                                            single-line
                                            hide-details
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="headersEvent"
                                    :hide-default-footer="true"
                                    :items="guestsByEvent"
                                    :search="searchEvents"
                                    :footer-props="{
                                                      itemsPerPageOptions: [
                                                          {text: '5', value: 5},
                                                          {text: '10', value: 10},
                                                          {text: '25', value: 25},
                                                          {text: this.$t('todos'), value: -1}
                                                      ],
                                                      itemsPerPageText: $t('filas_por_pagina')
                                                  }"
                                    :no-data-text="$t('no_records_yet')"
                                    class="elevation-1"
                                >
                                  <template v-slot:item.status="{ item }">
                                    <div v-if="item.status === 0">
                                        <v-btn
                                                :disabled="getProfile.role !== 4 "
                                                @click="checkInGuestByEvent(item)"
                                                color="primary">
                                            {{$t('complete_register')}}
                                        </v-btn>
                                    </div>
                                    <div v-else>
                                        <v-icon color="primary">mdi-check</v-icon>{{$t('adentro')}}
                                    </div>
                                  </template>
                                </v-data-table>
                            </v-flex>
                          </v-card-text>
                        </v-card>
                      </v-scroll-y-transition>
                    </v-col>
                  </v-row>
              </v-card-text>
              </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import store from '@/store'
import axios from 'axios'

const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
  name: 'events',
  created () {
    // this.getDirectory()
    this.getEvents()
    // this.getDelivery()
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
    items () {
      return [
        {
          name: 'Users',
          children: this.events
        }
      ]
    },
    selected () {
      if (!this.active.length) return undefined
      console.log('Llamar a la API')
      console.log('Valor de active = ', this.active[0])
      const id = this.active[0]
      console.log('Valor de event = ', this.events.find(event => event.id === id))
      this.getGuestsByEvent(this.events.find(event => event.id === id).id)
      return this.events.find(event => event.id === id)
    }
  },
  data: () => ({
    header: [],
    loadingDataDirectory: false,
    loadingDataEvents: false,
    loadingDataDelivery: false,
    directorys: [],
    events: [],
    deliverys: [],
    search: '',
    searchEvents: '',
    searchDelivery: '',
    headers: [],
    headers2: [],
    headers3: [],
    headers4: [],
    headers5: [],
    headers6: [],
    // VARIABLES DE ACCESO
    activar_camara: true,
    qr_code: '',
    error: '',
    valido: false,
    a_qr_code: '',
    salida: false,
    entrada: false,
    salidaTrabajador: false,
    entradaTrabajador: false,
    entradaResidente: false,
    data_access: [],
    errores_guard: '',
    head_color: '',
    info_invitation: [],
    dialog: false,
    comments: '',
    dialog_errores: false,
    dialogInitial: false,
    loading: false,
    guardHouse: null,
    guardHouses: [],
    // VARIABLES DE ACCESO
    // VARIABLES CORRECCION DE DATOS
    dialog_correction_request: false,
    first_name_correction: '',
    last_name_correction: '',
    id_user_settings: 0,
    errores: [],
    loading_correction_request: false,
    msg_photograph_blurred: true,
    // VARIABLES CORRECCION DE DATOS
    active: [],
    avatar: null,
    open: [],
    users: [],
    headersEvent: [],
    tabs: null,
    guestsByEvent: []
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'canceled'
      },
      {
        text: this.$t('Tipo'),
        align: 'center',
        sortable: true,
        value: 'type'
      },
      {
        text: this.$t('fecha_hora'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('fecha_expiracion'),
        align: 'center',
        sortable: true,
        value: 'expiration_format'
      },
      {
        text: this.$t('access_days'),
        align: 'center',
        sortable: true,
        value: 'diary'
      },
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: true,
        value: 'guest_name'
      },
      {
        text: this.$t('numero_casa'),
        align: 'center',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('Anfitrion'),
        align: 'center',
        sortable: true,
        value: 'host_name'
      }
    ]
    this.headers2 = [
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'canceled'
      },
      {
        text: this.$t('Tipo'),
        align: 'center',
        sortable: true,
        value: 'type'
      },
      {
        text: this.$t('fecha_hora'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('fecha_expiracion'),
        align: 'center',
        sortable: true,
        value: 'expiration_format'
      },
      {
        text: this.$t('access_days'),
        align: 'center',
        sortable: true,
        value: 'diary'
      },
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: true,
        value: 'guest_name'
      },
      {
        text: this.$t('numero_casa'),
        align: 'center',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('Anfitrion'),
        align: 'center',
        sortable: true,
        value: 'host_name'
      }
    ]
    this.headers3 = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('event'),
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('direccion'),
        align: 'center',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('Fecha'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('event_time'),
        align: 'center',
        sortable: true,
        value: 'time'
      }
    ]
    this.headers4 = [
      {
        text: this.$t('event'),
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('direccion'),
        align: 'center',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('Fecha'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('event_time'),
        align: 'center',
        sortable: true,
        value: 'time'
      }
    ]
    this.headers5 = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('code'),
        align: 'center',
        sortable: true,
        value: 'qrCode'
      },
      {
        text: this.$t('service_catalog'),
        align: 'center',
        sortable: true,
        value: 'nameDeliveryService'
      },
      {
        text: this.$t('direccion'),
        align: 'center',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'notes'
      }
    ]
    this.headers6 = [
      {
        text: this.$t('code'),
        align: 'center',
        sortable: true,
        value: 'qrCode'
      },
      {
        text: this.$t('service_catalog'),
        align: 'center',
        sortable: true,
        value: 'nameDeliveryService'
      },
      {
        text: this.$t('direccion'),
        align: 'center',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'notes'
      }
    ]
    this.headersEvent = [
      {
        text: this.$t('invitados'),
        align: 'left',
        sortable: true,
        value: 'fullName'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'status'
      }
    ]
  },
  methods: {
    async fetchUsers (item) {
      // Remove in 6 months and say
      // you've made optimizations! :)
      await pause(1500)

      return fetch('https://jsonplaceholder.typicode.com/users')
        .then(res => res.json())
        .then(json => (item.children.push(...json)))
        .catch(err => console.warn(err))
    },
    getDirectory () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Invitation/current',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.directorys = []
          } else {
            this.directorys = response.data
          }
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    },
    getDelivery () {
      this.loadingDataDelivery = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/delivery/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.deliverys = []
          } else {
            this.deliverys = response.data
          }
          this.loadingDataDelivery = false
        })
        .catch(error => {
          this.loadingDataDelivery = false
          console.log(error)
        })
    },
    getEvents () {
      this.loadingDataEvents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/event/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.events = []
          } else {
            this.events = response.data
          }
          this.loadingDataEvents = false
        })
        .catch(error => {
          this.loadingDataEvents = false
          console.log(error)
        })
    },
    getGuestsByEvent (uuid) {
      // this.loadingDataEvents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/event/' + uuid,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.searchEvents = ''
          if (response.status === 204) {
            this.guestsByEvent = []
          } else {
            this.guestsByEvent = response.data
          }
          // this.loadingDataEvents = false
        })
        .catch(error => {
          // this.loadingDataEvents = false
          console.log(error)
        })
    },
    checkInGuestByEvent (item) {
      console.log('item = ', item)
      console.log('this.eventData.idHouse = ', this.selected.idHouse)
      let qrDevice = false
      if (localStorage.getItem('banderaQR') !== null) {
        if (localStorage.getItem('banderaQR') === 'true') {
          qrDevice = true
        } else {
          qrDevice = false
        }
      }
      if (qrDevice) {
        if (this.getProfile.totem_with_plates === true) {
          console.log('CASO Totem CON Placas')
          this.$router.push({
            name: 'checkin_checkout_qr2',
            params: {
              fullNameGuest: item.fullName,
              idHouse: this.selected.idHouse,
              idGuestByEvent: item.id,
              eventName: this.selected.name,
              type: 0
            }
          })
        } else {
          console.log('CASO Totem SIN Placas')
          this.$router.push({
            name: 'checkin_checkout_qr',
            params: {
              fullNameGuest: item.fullName,
              idHouse: this.selected.idHouse,
              idGuestByEvent: item.id,
              eventName: this.selected.name,
              type: 0
            }
          })
        }
      } else {
        this.$router.push({
          name: 'access_without_code',
          params: {
            fullNameGuest: item.fullName,
            idHouse: this.selected.idHouse,
            idGuestByEvent: item.id,
            eventName: this.selected.name,
            type: 0
          }
        })
      }
    },
    checkInGuestByDelivery (item) {
      console.log('item = ', item)
      console.log('item.idHouse = ', item.idHouse)
      let qrDevice = false
      if (localStorage.getItem('banderaQR') !== null) {
        if (localStorage.getItem('banderaQR') === 'true') {
          qrDevice = true
        } else {
          qrDevice = false
        }
      }
      if (qrDevice) {
        if (this.getProfile.totem_with_plates === true) {
          console.log('CASO Totem CON Placas')
          this.$router.push({
            name: 'checkin_checkout_qr2',
            params: {
              idHouse: item.idHouse,
              idGuestByDelivery: item.id,
              type: 1,
              notes: item.nameDeliveryService
            }
          })
        } else {
          console.log('CASO Totem SIN Placas')
          this.$router.push({
            name: 'checkin_checkout_qr',
            params: {
              idHouse: item.idHouse,
              idGuestByDelivery: item.id,
              type: 1,
              notes: item.nameDeliveryService
            }
          })
        }
      } else {
        this.$router.push({
          name: 'access_without_code',
          params: {
            idHouse: item.idHouse,
            idGuestByDelivery: item.id,
            type: 1,
            notes: item.nameDeliveryService
          }
        })
      }
    },
    sendQRCode (aQRCode) {
      console.log(aQRCode)
      let qrDevice = false
      if (localStorage.getItem('banderaQR') !== null) {
        if (localStorage.getItem('banderaQR') === 'true') {
          qrDevice = true
        } else {
          qrDevice = false
        }
      }
      if (qrDevice) {
        let devicesAux = JSON.parse(localStorage.getItem('qr_devices'))
        const config = {
          method: 'POST',
          url: 'https://residencial-services.intrare.app/devices_hw/' + devicesAux[0].uuid + '/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            qr_data: aQRCode
          }
        }
        axios(config)
          .then(response => {
            if (this.getProfile.totem_with_plates === true) {
              this.$router.push('/checkin_checkout_qr2/1')
            } else {
              this.$router.push('/checkin_checkout_qr/1')
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        // IMPLEMENTAR LA LOGICA DE ACCESOS AQUI
        // this.$store.commit('snackbar_activate_true')
        // this.$store.commit('snackbar_change_message', 'Favor de presionar el boton Enviar, para Registrar Entrada/Salida')
        // setTimeout(this.clear, 5000)
        // localStorage.setItem('qr_code_temporal', aQRCode)
        // this.$router.push('/checkin_checkout')
        this.a_qr_code = aQRCode
        this.get_invitation_manual()
      }
    },
    get_invitation_manual: function () {
      console.log(this.a_qr_code)
      this.loading = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/vigilant/qr/' + this.a_qr_code,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.info_invitation = response.data
          console.log(this.info_invitation)
          this.valido = true
          console.log('Valido')
          if (this.info_invitation.type_code === 0) {
            console.log('Acceso por Invitación')
            this.is_access_in_out_both()
          }
          if (this.info_invitation.type_code === 1) {
            console.log('Acceso Residente del Fraccionamiento')
            this.entrada = false
            this.salida = false
            this.entradaResidente = true
            this.dialog = true
            this.activar_camara = false
          }
          if (this.info_invitation.type_code === 2) {
            console.log('Acceso Trabajador')
            this.is_worker_access_in_out_both()
          }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
          if (error.request.status === 404) {
            this.valido = false
            console.log('NO Valido')
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('mensaje_qr_no_valido')
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          }
          if (error.request.status === 401) {
            this.valido = false
            console.log('Invitacion Expirada')
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('msg_out_date2')
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          }
          if (error.request.status === 403) {
            this.valido = false
            console.log('NO Valido')
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('msg_canceled_invitation')
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          }
          if (error.request.status === 423) {
            this.valido = false
            console.log('NO Valido')
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('msg_vacation_mode_activate')
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          }
          if (error.request.status === 300) {
            this.valido = false
            console.log('Varios registros con el mismo Código QR.')
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('mensaje_qr_multiple')
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          }
        })
    },
    clear_without_activate_camera: function () {
      this.dialog = false
      this.activar_camara = false
      this.qr_code = ''
      this.a_qr_code = ''
      this.entrada = false
      this.salida = false
      this.entradaTrabajador = false
      this.salidaTrabajador = false
    },
    is_access_in_out_both: function () {
      if (this.a_qr_code.length > 10) {
        this.qr_code = this.a_qr_code
      }
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Access/Get/ByCode/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.data_access = response.data
          console.log(this.data_access)
          if (this.info_invitation.invitation.typeInv === 0) { // Tipo de Invitación Normal
            if (response.data.length > 0 && response.data[0].dateTime_EntranceAccess != null && response.data[0].dateTime_ExitAccess != null) {
              // alert('Ya se completó el acceso con la invitación Correspondiente.')
              console.log('COMPLETO')
              this.clear_without_activate_camera()
              this.head_color = 'orange display-1 text--primary justify-center'
              this.errores_guard = this.$t('mensaje_acceso_completo')
              this.dialog_errores = true
            } else {
              // this.get_equipo_invitacion()
              if (response.data.length > 0) {
                this.entrada = false
                this.salida = true
                this.dialog = true
                this.activar_camara = false
                console.log('SALIDA')
              } else {
                console.log('ENTRADA')
                if (this.info_invitation.invitation.temporalToken === '') {
                  this.comments = ''
                  this.entrada = true
                  this.salida = false
                  this.dialog = true
                  this.activar_camara = false
                } else {
                  localStorage.setItem('qr_code_temporal', this.qr_code)
                  localStorage.setItem('host_IdFront', this.info_invitation.invitation.hostIdFront)
                  localStorage.setItem('host_avatar', this.info_invitation.invitation.avatarHost)
                  localStorage.setItem('host_first_name', this.info_invitation.invitation.hostFirstName)
                  localStorage.setItem('host_last_name', this.info_invitation.invitation.hostLastName)
                  localStorage.setItem('host_cellphone', this.info_invitation.invitation.hostCellphone)
                  localStorage.setItem('host_street', this.info_invitation.invitation.street)
                  localStorage.setItem('host_number_house', this.info_invitation.invitation.numberHouse)
                  localStorage.setItem('host_supplier', this.info_invitation.invitation.supplier)
                  localStorage.setItem('vacation_mode', this.info_invitation.invitation.vacation_mode)
                  localStorage.setItem('allow_access_visitors', this.info_invitation.invitation.allow_access_visitors)
                  this.$router.push('/booth_registration/' + this.info_invitation.invitation.temporalToken)
                }
              }
            }
          }
          if (this.info_invitation.invitation.typeInv === 1) { // Tipo de Invitación Pre registro en Caseta
            if (response.data.length > 0 && response.data[0].dateTime_EntranceAccess != null && response.data[0].dateTime_ExitAccess != null) {
              // alert('Ya se completó el acceso con la invitación Correspondiente.')
              console.log('COMPLETO')
              this.clear_without_activate_camera()
              this.head_color = 'orange display-1 text--primary justify-center'
              this.errores_guard = this.$t('mensaje_acceso_completo')
              this.dialog_errores = true
            } else {
              if (response.data.length > 0) {
                this.entrada = false
                this.salida = true
                this.dialog = true
                this.activar_camara = false
                console.log('SALIDA')
              } else {
                console.log('ENTRADA')
                if (this.info_invitation.invitation.temporalToken === '') {
                  this.comments = ''
                  this.entrada = true
                  this.salida = false
                  this.dialog = true
                  this.activar_camara = false
                } else {
                  localStorage.setItem('qr_code_temporal', this.qr_code)
                  localStorage.setItem('host_IdFront', this.info_invitation.invitation.hostIdFront)
                  localStorage.setItem('host_avatar', this.info_invitation.invitation.avatarHost)
                  localStorage.setItem('host_first_name', this.info_invitation.invitation.hostFirstName)
                  localStorage.setItem('host_last_name', this.info_invitation.invitation.hostLastName)
                  localStorage.setItem('host_cellphone', this.info_invitation.invitation.hostCellphone)
                  localStorage.setItem('host_street', this.info_invitation.invitation.street)
                  localStorage.setItem('host_number_house', this.info_invitation.invitation.numberHouse)
                  localStorage.setItem('host_supplier', this.info_invitation.invitation.supplier)
                  localStorage.setItem('vacation_mode', this.info_invitation.invitation.vacation_mode)
                  localStorage.setItem('allow_access_visitors', this.info_invitation.invitation.allow_access_visitors)
                  this.$router.push('/booth_registration/' + this.info_invitation.invitation.temporalToken)
                }
              }
            } // Tipo de Invitación Recurrente
          }
          if (this.info_invitation.invitation.typeInv === 2) { // Tipo de Invitación Recurrente
            if (response.data.length === 0) {
              console.log('ENTRADA RECURRENTE')
              if (this.info_invitation.invitation.temporalToken === '') {
                this.comments = ''
                this.entrada = true
                this.salida = false
                this.dialog = true
                this.activar_camara = false
              } else {
                localStorage.setItem('qr_code_temporal', this.qr_code)
                localStorage.setItem('host_IdFront', this.info_invitation.invitation.hostIdFront)
                localStorage.setItem('host_avatar', this.info_invitation.invitation.avatarHost)
                localStorage.setItem('host_first_name', this.info_invitation.invitation.hostFirstName)
                localStorage.setItem('host_last_name', this.info_invitation.invitation.hostLastName)
                localStorage.setItem('host_cellphone', this.info_invitation.invitation.hostCellphone)
                localStorage.setItem('host_street', this.info_invitation.invitation.street)
                localStorage.setItem('host_number_house', this.info_invitation.invitation.numberHouse)
                localStorage.setItem('host_supplier', this.info_invitation.invitation.supplier)
                localStorage.setItem('vacation_mode', this.info_invitation.invitation.vacation_mode)
                localStorage.setItem('allow_access_visitors', this.info_invitation.invitation.allow_access_visitors)
                this.$router.push('/booth_registration/' + this.info_invitation.invitation.temporalToken)
              }
            } else {
              if (response.data[0].status === 1) {
                this.entrada = false
                this.salida = true
                this.dialog = true
                this.activar_camara = false
                console.log('SALIDA RECURRENTE', response.data[0])
              } else {
                var fechaLocal = new Date(this.get_current_date())
                const readableDate = response.data[0].dateTime_EntranceAccess.substring(3, 6) + response.data[0].dateTime_EntranceAccess.substring(0, 2) + response.data[0].dateTime_EntranceAccess.substring(5, 10)
                var fechaAccesoEntrada = new Date(readableDate)
                if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                  this.comments = ''
                  this.entrada = true
                  this.salida = false
                  this.dialog = true
                  this.activar_camara = false
                  console.log('ENTRADA RECURRENTE')
                } else {
                  console.log('COMPLETO RECURRENTE')
                  this.clear_without_activate_camera()
                  this.head_color = 'orange display-1 text--primary justify-center'
                  this.errores_guard = this.$t('mensaje_acceso_completo')
                  this.dialog_errores = true
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    create_acceso: function () {
      console.log(this.qr_code)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/Access/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: this.qr_code,
          comments: this.comments,
          id_guardhouse_checkin: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          // this.$store.commit('snackbar_activate_true')
          // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
          // this.dialog = false
          // setTimeout(this.clear, 3000);
          // console.log(this.info_invitation)
          localStorage.removeItem('qr_code_temporal')
          this.clear_without_activate_camera()
          this.errores_guard = this.$t('mensaje_alta_acceso_in')
          this.head_color = 'green display-1 text--primary justify-center'
          this.dialog_errores = true
        })
        .catch(error => {
          console.log(error.response.data)
          this.clear_without_activate_camera()
          this.head_color = 'red display-1 text--primary justify-center'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    create_worker_acceso: function () {
      console.log(this.qr_code)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: this.info_invitation.worker.qr_code,
          guard_house: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          localStorage.removeItem('qr_code_temporal')
          if (this.entradaTrabajador === true) {
            this.errores_guard = this.$t('mensaje_alta_acceso_in')
          }
          if (this.salidaTrabajador === true) {
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
          }
          this.clear_without_activate_camera()
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
        })
        .catch(error => {
          console.log(error.response.data)
          this.clear_without_activate_camera()
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    update_acceso: function (pk) {
      console.log(this.qr_code)
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/Access/Update/' + pk,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          this.clear_without_activate_camera()
          this.head_color = 'green display-1 text--primary'
          this.errores_guard = this.$t('mensaje_alta_acceso_out')
          this.dialog_errores = true
          // this.$store.commit('snackbar_activate_true')
          // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
          // setTimeout(this.clear, 3000);
        })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    send_correction_request: function () {
      this.errores = []
      this.loading_correction_request = true
      console.log(this.qr_code)
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/user/update/correction_request/' + this.id_user_settings,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          first_name: this.first_name_correction,
          last_name: this.last_name_correction
        }
      }
      axios(config)
        .then(response => {
          this.loading_correction_request = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('registro_exito'))
          this.dialog_correction_request = false
          this.get_invitation_manual()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading_correction_request = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    is_worker_access_in_out_both () {
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Status/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          'qr_code': this.info_invitation.worker.qr_code
        }
      }
      axios(config)
        .then(response => {
          switch (response.data.status) {
            case 10:
              console.log('ENTRADA TRABAJADOR')
              this.entradaTrabajador = true
              this.salidaTrabajador = false
              this.dialog = true
              this.activar_camara = false
              break
            case 11:
              console.log('SALIDA TRABAJADOR')
              this.entradaTrabajador = false
              this.salidaTrabajador = true
              this.dialog = true
              this.activar_camara = false
              break
            case 12:
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_worker0')
              this.dialog_errores = true
              break
            case 13:
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_worker1')
              this.dialog_errores = true
              break
          }
        })
        .catch(error => {
          console.log(error.response.data)
        })
    },
    getGuardHouse: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/guardhouse/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guardHouses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse)
        this.dialogInitial = false
      }
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #439f46;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    th {
        text-align: left;
    }
    table, th, td {
      border:1px solid black;
    }

    th, td {
      text-align: center;
      padding: 8px;
    }

    tr:nth-child(even) {
      background-color: #D6EEEE;
    }
</style>
